// Form Validation Configuration
var zf_DateRegex = new RegExp(
  "^(([0][1-9])|([1-2][0-9])|([3][0-1]))[-](Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec|JAN|FEB|MAR|APR|MAY|JUN|JUL|AUG|SEP|OCT|NOV|DEC)[-](?:(?:19|20)[0-9]{2})$"
);

var zf_MandArray = ["SingleLine", "SingleLine1", "PhoneNumber_countrycode", "Email"];
var zf_FieldArray = ["SingleLine", "SingleLine1", "PhoneNumber_countrycode", "Email"];
var isSalesIQIntegrationEnabled = false;
var salesIQFieldsArray = [];

// Main validation function
function zf_ValidateAndSubmit() {
  // Clear all previous errors first
  var allErrors = document.querySelectorAll('.zf-errorMessage');
  allErrors.forEach(function(error) {
    error.style.display = 'none';
  });
  
  var isValid = true;
  var firstErrorField = null;
  
  // Validate First Name
  var firstNameField = document.getElementById('firstName');
  if (firstNameField) {
    var firstName = firstNameField.value.replace(/^\s+|\s+$/g, '');
    if (firstName === '') {
      document.getElementById('SingleLine_error').textContent = "الاسم الاول مطلوب";
      document.getElementById('SingleLine_error').style.display = 'block';
      isValid = false;
      if (!firstErrorField) firstErrorField = firstNameField;
    } else if (!zf_ValidateName(firstNameField)) {
      document.getElementById('SingleLine_error').textContent = firstNameField.getAttribute('data-error') || "اسم غير صحيح";
      document.getElementById('SingleLine_error').style.display = 'block';
      isValid = false;
      if (!firstErrorField) firstErrorField = firstNameField;
    }
  }
  
  // Validate Last Name
  var lastNameField = document.getElementById('lastName');
  if (lastNameField) {
    var lastName = lastNameField.value.replace(/^\s+|\s+$/g, '');
    if (lastName === '') {
      document.getElementById('SingleLine1_error').textContent = "اسم العائلة مطلوب";
      document.getElementById('SingleLine1_error').style.display = 'block';
      isValid = false;
      if (!firstErrorField) firstErrorField = lastNameField;
    } else if (!zf_ValidateName(lastNameField)) {
      document.getElementById('SingleLine1_error').textContent = lastNameField.getAttribute('data-error') || "اسم غير صحيح";
      document.getElementById('SingleLine1_error').style.display = 'block';
      isValid = false;
      if (!firstErrorField) firstErrorField = lastNameField;
    }
  }
  
  // Validate Phone using intl-tel-input
  var phoneField = document.getElementById('phone');
  if (phoneField && window.itiInstance) {
    var phone = phoneField.value.replace(/^\s+|\s+$/g, '');
    
    if (phone === '') {
      document.getElementById('PhoneNumber_error').textContent = "رقم الهاتف مطلوب";
      document.getElementById('PhoneNumber_error').style.display = 'block';
      isValid = false;
      if (!firstErrorField) firstErrorField = phoneField;
    } else if (!window.itiInstance.isValidNumber()) {
      document.getElementById('PhoneNumber_error').textContent = "رقم هاتف غير صحيح للدولة المحددة";
      document.getElementById('PhoneNumber_error').style.display = 'block';
      isValid = false;
      if (!firstErrorField) firstErrorField = phoneField;
    } else {
      // If valid, set the full international number
      var fullNumber = window.itiInstance.getNumber();
      phoneField.value = fullNumber;
      
      // Update hidden country field
      var countryData = window.itiInstance.getSelectedCountryData();
      document.getElementById('derivedCountry').value = countryData.name;
    }
  }
  
  // Validate Email
  var emailField = document.getElementById('email');
  if (emailField) {
    var email = emailField.value.replace(/^\s+|\s+$/g, '');
    if (email === '') {
      document.getElementById('Email_error').textContent = "البريد الالكتروني مطلوب";
      document.getElementById('Email_error').style.display = 'block';
      isValid = false;
      if (!firstErrorField) firstErrorField = emailField;
    } else if (!zf_ValidateEmailID(emailField)) {
      document.getElementById('Email_error').textContent = emailField.getAttribute('data-error') || "البريد الالكتروني غير صحيح";
      document.getElementById('Email_error').style.display = 'block';
      isValid = false;
      if (!firstErrorField) firstErrorField = emailField;
    }
  }
  
  // Focus on first error field
  if (!isValid && firstErrorField) {
    firstErrorField.focus();
    // Scroll to first error
    firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  
  return isValid;
}

// Custom name validation
function zf_ValidateName(elem) {
  var nameValue = elem.value.replace(/^\s+|\s+$/g, '');
  
  if (nameValue === "") {
    elem.setAttribute('data-error', "الاسم مطلوب");
    return false;
  }
  
  // Check for numbers
  if (/\d/.test(nameValue)) {
    elem.setAttribute('data-error', 'لا يمكن أن يحتوي الاسم على أرقام');
    return false;
  }
  
  // Check length (max 10 characters)
  if (nameValue.length > 10) {
    elem.setAttribute('data-error', 'لا يمكن أن يتجاوز الاسم 10 حرفًا');
    return false;
  }
  
  // Check for valid characters (letters, spaces, hyphens, apostrophes)
  if (!/^[a-zA-Z\s\-']+$/.test(nameValue)) {
    elem.setAttribute('data-error', 'يحتوي الاسم على أحرف غير صالحة');
    return false;
  }

  // Count the number of uppercase letters
  var uppercaseLetters = nameValue.match(/[A-Z]/g);
  var uppercaseCount = uppercaseLetters ? uppercaseLetters.length : 0;
  
  // Fail if there is more than one uppercase letter
  if (uppercaseCount > 1) {
    elem.setAttribute('data-error', 'يُسمح بحرف كبير واحد (Capital) على الأكثر');
    return false;
  }
  
  elem.removeAttribute('data-error');
  return true;
}

// Enhanced email validation
function zf_ValidateEmailID(elem) {
  var emailValue = elem.value.replace(/^\s+|\s+$/g, '');
  
  if (emailValue === "") {
    elem.setAttribute('data-error', 'البريد الإلكتروني مطلوب');
    return false;
  }
  
  // Basic email format validation
  var emailExp = /^[\w]([\w\-.+&'/]*)@([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
  if (!emailExp.test(emailValue)) {
    elem.setAttribute('data-error', 'الرجاء إدخال عنوان بريد إلكتروني صالح');
    return false;
  }
  
  // Extract domain
  var domain = emailValue.split('@')[1].toLowerCase();
  
  // List of disposable/temporary email domains to block
  var disposableDomains = [
    'tempmail.com', 'throwaway.email', 'guerrillamail.com', 
    'mailinator.com', '10minutemail.com', 'trashmail.com',
    'fakeinbox.com', 'yopmail.com', 'getnada.com', 
  ];
  
  if (disposableDomains.includes(domain)) {
    elem.setAttribute('data-error', 'الرجاء استخدام نطاق بريد إلكتروني صالح (وليس بريدًا مؤقتًا)');
    return false;
  }
  
  elem.removeAttribute('data-error');
  return true;
}

// Enhanced phone validation using intl-tel-input
function zf_ValidatePhone(inpElem) {
  var phoneValue = inpElem.value.replace(/^\s+|\s+$/g, '');
  
  if (phoneValue === "") {
    inpElem.setAttribute('data-error', 'رقم الهاتف مطلوب');
    return false;
  }
  
  // If intl-tel-input is available, use its validation
  if (window.itiInstance) {
    if (!window.itiInstance.isValidNumber()) {
      inpElem.setAttribute('data-error', 'رقم هاتف غير صحيح للدولة المحددة');
      return false;
    }
  } else {
    // Fallback validation if intl-tel-input is not loaded
    var cleanPhone = phoneValue.replace(/[\s\-()]/g, '');
    
    if (!/^\+?\d+$/.test(cleanPhone)) {
      inpElem.setAttribute('data-error', 'يجب أن يحتوي رقم الهاتف على أرقام فقط');
      return false;
    }
    
    if (cleanPhone.length < 7) {
      inpElem.setAttribute('data-error','رقم الهاتف قصير جدًا (7 أرقام على الأقل)');
      return false;
    }
    
    if (cleanPhone.length > 15) {
      inpElem.setAttribute('data-error', 'رقم الهاتف طويل جدًا (15 رقمًا على الأكثر)');
      return false;
    }
  }
  
  inpElem.removeAttribute('data-error');
  return true;
}

// Show error message
function zf_ShowErrorMsg(uniqName) {
  var fldLinkName;
  for (errInd = 0; errInd < zf_FieldArray.length; errInd++) {
    fldLinkName = zf_FieldArray[errInd].split('_')[0];
    var errorElem = document.getElementById(fldLinkName + "_error");
    if (errorElem) {
      errorElem.style.display = 'none';
    }
  }
  
  var linkName = uniqName.split('_')[0];
  var errorElem = document.getElementById(linkName + "_error");
  var fieldObj = document.forms.form[uniqName];
  
  if (errorElem && fieldObj) {
    var customError = fieldObj.getAttribute('data-error');
    if (customError) {
      errorElem.textContent = customError;
    } else {
      errorElem.textContent = "الحقل مطلوب";
    }
    errorElem.style.display = 'block';
  }
}

// Real-time validation on blur
document.addEventListener('DOMContentLoaded', function() {
  // First Name validation
  var firstNameField = document.getElementById('firstName');
  if (firstNameField) {
    firstNameField.addEventListener('blur', function() {
      zf_ValidateName(this);
      if (this.value.trim() !== '') {
        if (this.getAttribute('data-error')) {
          document.getElementById('SingleLine_error').textContent = this.getAttribute('data-error');
          document.getElementById('SingleLine_error').style.display = 'block';
        } else {
          document.getElementById('SingleLine_error').style.display = 'none';
        }
      }
    });
  }
  
  // Last Name validation
  var lastNameField = document.getElementById('lastName');
  if (lastNameField) {
    lastNameField.addEventListener('blur', function() {
      zf_ValidateName(this);
      if (this.value.trim() !== '') {
        if (this.getAttribute('data-error')) {
          document.getElementById('SingleLine1_error').textContent = this.getAttribute('data-error');
          document.getElementById('SingleLine1_error').style.display = 'block';
        } else {
          document.getElementById('SingleLine1_error').style.display = 'none';
        }
      }
    });
  }
  
  // Email validation
  var emailField = document.getElementById('email');
  if (emailField) {
    emailField.addEventListener('blur', function() {
      zf_ValidateEmailID(this);
      if (this.value.trim() !== '') {
        if (this.getAttribute('data-error')) {
          document.getElementById('Email_error').textContent = this.getAttribute('data-error');
          document.getElementById('Email_error').style.display = 'block';
        } else {
          document.getElementById('Email_error').style.display = 'none';
        }
      }
    });
  }
  
  // Phone validation with intl-tel-input
  var phoneField = document.getElementById('phone');
  if (phoneField) {
    phoneField.addEventListener('blur', function() {
      if (this.value.trim() !== '') {
        zf_ValidatePhone(this);
        if (this.getAttribute('data-error')) {
          document.getElementById('PhoneNumber_error').textContent = this.getAttribute('data-error');
          document.getElementById('PhoneNumber_error').style.display = 'block';
        } else {
          document.getElementById('PhoneNumber_error').style.display = 'none';
        }
      }
    });
    
    // Clear error on input
    phoneField.addEventListener('input', function() {
      document.getElementById('PhoneNumber_error').style.display = 'none';
    });
  }
});

// Placeholder functions for signature (if needed)
function zf_MandatoryCheckSignature(objElem) {
  return true;
}

function zf_ValidateSignature(objElem) {
  return true;
}

// Check mandatory fields (kept for compatibility)
function zf_CheckMandatory() {
  for (i = 0; i < zf_MandArray.length; i++) {
    var fieldObj = document.forms.form[zf_MandArray[i]];
    if (fieldObj) {
      if (fieldObj.nodeName != null) {
        if (fieldObj.nodeName == 'OBJECT') {
          if (!zf_MandatoryCheckSignature(fieldObj)) {
            zf_ShowErrorMsg(zf_MandArray[i]);
            return false;
          }
        } else if (((fieldObj.value).replace(/^\s+|\s+$/g, '')).length == 0) {
          if (fieldObj.type == 'file') {
            fieldObj.focus();
            zf_ShowErrorMsg(zf_MandArray[i]);
            return false;
          }
          fieldObj.focus();
          zf_ShowErrorMsg(zf_MandArray[i]);
          return false;
        } else if (fieldObj.nodeName == 'SELECT') {
          if (fieldObj.options[fieldObj.selectedIndex].value == '-Select-') {
            fieldObj.focus();
            zf_ShowErrorMsg(zf_MandArray[i]);
            return false;
          }
        } else if (fieldObj.type == 'checkbox' || fieldObj.type == 'radio') {
          if (fieldObj.checked == false) {
            fieldObj.focus();
            zf_ShowErrorMsg(zf_MandArray[i]);
            return false;
          }
        }
      } else {
        var checkedValsCount = 0;
        var inpChoiceElems = fieldObj;
        for (var ii = 0; ii < inpChoiceElems.length; ii++) {
          if (inpChoiceElems[ii].checked === true) {
            checkedValsCount++;
          }
        }
        if (checkedValsCount == 0) {
          inpChoiceElems[0].focus();
          zf_ShowErrorMsg(zf_MandArray[i]);
          return false;
        }
      }
    }
  }
  return true;
}

// Validate all fields (kept for compatibility)
function zf_ValidCheck() {
  var isValid = true;
  for (ind = 0; ind < zf_FieldArray.length; ind++) {
    var fieldObj = document.forms.form[zf_FieldArray[ind]];
    if (fieldObj) {
      if (fieldObj.nodeName != null) {
        var checkType = fieldObj.getAttribute("checktype");
        if (checkType == "c1") {
          if (!zf_ValidateName(fieldObj)) {
            isValid = false;
            fieldObj.focus();
            zf_ShowErrorMsg(zf_FieldArray[ind]);
            return false;
          }
        } else if (checkType == "c5") {
          if (!zf_ValidateEmailID(fieldObj)) {
            isValid = false;
            fieldObj.focus();
            zf_ShowErrorMsg(zf_FieldArray[ind]);
            return false;
          }
        } else if (checkType == "c7") {
          if (!zf_ValidatePhone(fieldObj)) {
            isValid = false;
            fieldObj.focus();
            zf_ShowErrorMsg(zf_FieldArray[ind]);
            return false;
          }
        }
      }
    }
  }
  return isValid;
}